import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const wizardEntitiesStage = tv({
  slots: {
    root: "flex w-full flex-1 flex-col gap-6 py-8",
    header: "flex items-start justify-between gap-4",
    headings: "flex flex-col gap-2",
    heading: "text-2xl font-bold text-neutral-800 lg:text-3xl",
    helper: "text-base text-secondary lg:text-lg",
    headerAction: "shrink-0",
    body: "flex flex-1 flex-col",
  },
});

export interface WizardEntitiesStageProps {
  heading: string;
  helper?: string;
  /** Optional top-right action (typically an icon button to add a new entity). */
  headerAction?: ReactNode;
  /** Body content — caller composes `EmptyState` or a list/grid as appropriate. */
  children: ReactNode;
}

/** Shape 2: entity-management stage. Used when the stage manages a collection
 *  (photos, family members, etc.) and the controls are themselves entities with
 *  their own create/edit/delete affordances. */
export function WizardEntitiesStage({ heading, helper, headerAction, children }: WizardEntitiesStageProps) {
  const styles = wizardEntitiesStage();

  return (
    <div className={styles.root()}>
      <div className={styles.header()}>
        <div className={styles.headings()}>
          <h1 className={styles.heading()}>{heading}</h1>
          {helper ? <p className={styles.helper()}>{helper}</p> : null}
        </div>
        {headerAction ? <div className={styles.headerAction()}>{headerAction}</div> : null}
      </div>
      <div className={styles.body()}>{children}</div>
    </div>
  );
}
